export const version = '3.1.3'
export const name = 'js-libp2p'
